import { flexRender } from "@tanstack/react-table";
import { BsFillArrowDownCircleFill } from "react-icons/bs";
import { IoChevronDown } from "react-icons/io5";
import Skeleton from "react-loading-skeleton";
import BotaoFiltrar from "../../components/botaofiltrar";
import DocView from "../../components/docview";
import MensagemListaVazia from "../../components/mensagemlistavazia";
import Options from "../../components/select/options";
import Subtitle from "../../components/subtitle";
import Text from "../../components/text";
import useIsMobile from "../../hooks/useIsMobile";
import { BotaoEmpresa, CheckLabel, CheckOption, Container, ContainerSelecao, DownloadSelectedFilesButton, DropDown, EmpresasContainer, FilterContainer, InputContainer, InputDate, LinhaSkeleton } from "./styles";
import useDocs from "./useDocumentos";
import TabelaDocumentos from "./tabelaDocumentos";




const Documentos: React.FC = () => {

  const {
    filtrosAtuais,
    filtroAberto,
    carregando,
    documentoAberto,
    modalDocumentoAberto,
    empresas,
    locais,
    empresasDisponiveis,
    empresaSelecionada,
    tiposDocumento,
    tipoSelecionado,
    mostrarLista,
    listaAMostrar,
    opcoes,
    acaoCarregando,
    carregarDocumentos,
    selecionarEmpresa,
    abrirDocumento,
    fecharDocumento,
    baixarArquivo,
    atualizarValoresFiltros,
    abrirOpcoes,
    fecharOpcoes,

  } = useDocs();

  const isMobile = useIsMobile();



  function Placeholder() {
    return (
      <>
        <Skeleton height={20} width={'20%'} style={{ marginBottom: 30 }} />

        {Array(1).fill(0).map((item, index) => (
          <>
            <Skeleton height={20} width={'10%'} key={index} />
            <LinhaSkeleton key={index + 1}>
              {Array(4).fill(0).map((item, index) => <Skeleton height={40} key={index} />)}
            </LinhaSkeleton>
          </>
        ))}
      </>
    )
  }



  return (
    <Container paddingLateral={20}>

      {modalDocumentoAberto && <DocView file={documentoAberto} closeView={fecharDocumento} />}

      {!!filtroAberto &&
        <Options close={fecharOpcoes} selectOption={valor => atualizarValoresFiltros(valor, filtroAberto)} itens={opcoes[filtroAberto]} />}


      <>
        {!!tiposDocumento &&
          <FilterContainer className="max-[1270px]:!justify-between">
            <div className={`flex gap-5 max-[480px]:gap-0 ${!!tipoSelecionado && tipoSelecionado.value !== 0 && tipoSelecionado?.grupoFiltros === 8 && ' max-[1270px]:flex-col max-[1270px]:w-full max-[1270px]:max-w-[500px] max-[1024px]:max-w-full max-[1024px]:w-auto max-[1024px]:flex-row  max-[750px]:flex-col max-[547px]:w-full'} ${!!tipoSelecionado && tipoSelecionado.value !== 0 && '!gap-5 max-[550px]:flex-col max-[550px]:max-w-full max-[550px]:w-full'} max-[480px]:!w-full`}>
              <div className="flex gap-5 w-full max-[480px]:flex-col">
                <InputContainer className={`${!!tipoSelecionado && tipoSelecionado.value !== 0 && tipoSelecionado?.grupoFiltros === 8 && 'max-[1270px]:!w-full'} ${!!tipoSelecionado && tipoSelecionado.value !== 0 && 'max-[550px]:!w-full'} max-[480px]:!w-full`}>
                  <Subtitle className='!text-[.875rem]'>Tipo de Documento</Subtitle>
                  <DropDown className={`${!!tipoSelecionado && tipoSelecionado.value !== 0 && tipoSelecionado?.grupoFiltros === 8 && 'max-[1270px]:!w-full'} ${!!tipoSelecionado && tipoSelecionado.value !== 0 && 'max-[550px]:!w-full'} max-[480px]:!w-full`} onClick={() => abrirOpcoes('tipoDocumento')}>
                    <Text className="!overflow-ellipsis !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">
                      {filtrosAtuais?.tipoDocumento !== null ? tipoSelecionado?.label : 'Escolha o tipo de documento'}
                    </Text>
                    <IoChevronDown size={12} />
                  </DropDown>

                </InputContainer>


                <InputContainer className={`${!!tipoSelecionado && tipoSelecionado.value !== 0 && tipoSelecionado?.grupoFiltros === 8 && 'max-[1270px]:!w-full'} ${!!tipoSelecionado && tipoSelecionado.value !== 0 && 'max-[550px]:!w-full'} max-[480px]:!w-full`}>
                  <Subtitle className='!text-[.875rem]'>{"Ano e mês"}</Subtitle>
                  <div className={`row relative max-[480px]:!w-full ${!!tipoSelecionado && tipoSelecionado.value !== 0 && tipoSelecionado?.grupoFiltros === 8 && 'max-[1270px]:!w-full'} ${!!tipoSelecionado && tipoSelecionado.value !== 0 && 'max-[550px]:!w-full'} `}>
                    <InputDate
                      type={"month"}
                      onChange={e => atualizarValoresFiltros(e.target.value, 'dataInicial')}
                      max={"9999-12"}
                      value={filtrosAtuais?.dataInicial}
                      disabled={carregando}
                      className={`${!!tipoSelecionado && tipoSelecionado.value !== 0 && tipoSelecionado?.grupoFiltros === 8 && 'max-[1270px]:!w-full'} ${!!tipoSelecionado && tipoSelecionado.value !== 0 && 'max-[550px]:!w-full'} max-[480px]:!w-full`}
                    />
                    {isMobile && <IoChevronDown size={12} className="text-[rgba(0,0,0,0.5)] absolute right-[14px] top-[50%] translate-y-[-50%] pointer-events-none" />}
                  </div>
                </InputContainer>
              </div>

              <div className={`flex gap-5 'max-[1270px]:!w-full' max-[480px]:flex-col `}>
                {!!tipoSelecionado && tipoSelecionado.value !== 0 &&
                  <InputContainer className='max-[1270px]:!w-full !min-w-[115px]'>
                    <Subtitle className='!text-[.875rem]'>Empresa</Subtitle>
                    <DropDown className='max-[1270px]:!w-full !min-w-[115px]' onClick={() => abrirOpcoes('empresa')}>
                      <Text className="!overflow-ellipsis !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{!!filtrosAtuais?.empresa ? empresas?.find(item => item.value === filtrosAtuais.empresa)?.label : "Todas"}</Text>
                      <IoChevronDown size={12} />
                    </DropDown>
                  </InputContainer>
                }


                {tipoSelecionado?.grupoFiltros === 8 &&
                  <InputContainer className='max-[1270px]:!w-full !min-w-[115px]'>
                    <Subtitle className='!text-[.875rem]'>Local</Subtitle>
                    <DropDown className='max-[1270px]:!w-full !min-w-[115px]' onClick={() => abrirOpcoes('local')}>
                      <Text className="!overflow-ellipsis !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{!!filtrosAtuais?.local ? locais?.find(item => item.value === filtrosAtuais.local)?.label : "Todos"}</Text>
                      <IoChevronDown size={12} />
                    </DropDown>
                  </InputContainer>
                }
              </div>
            </div>
            <BotaoFiltrar loading={carregando} onClick={carregarDocumentos}>Buscar</BotaoFiltrar>

          </FilterContainer>
        }


        <EmpresasContainer>
          {empresasDisponiveis?.map(item =>
            <BotaoEmpresa selecionado={empresaSelecionada === item.empresa} onClick={() => selecionarEmpresa(item.empresa)}>
              {item.nome}
            </BotaoEmpresa>
          )}
        </EmpresasContainer>
      </>

      {!carregando && mostrarLista &&
        <TabelaDocumentos listaDocumentos={listaAMostrar} abrirDocumento={abrirDocumento} baixarArquivo={baixarArquivo} acaoCarregando={acaoCarregando}/>        
      }


      {!mostrarLista && !carregando &&
        <MensagemListaVazia
          texto={'Filtre para buscar documentos'}
          textoSecundario={'Não há dados a serem mostrados'}
        />}



      {carregando && <Placeholder />}

    </Container>
  )
}



export default Documentos;